<template>
  <div id="home">
    <div class="home__top">
      <div class="home__head">
        <div class="home__title">
          <div>Bei Auszeit finden Sie</div>
          <div>die Weinreise, die zu Ihnen passt!</div>
        </div>
        <div class="home__subtitle">
          <div>Verbinden Sie edlen Weingenuss</div>
          <div>mit Ihrer Leidenschaft</div>
        </div>
      </div>
      <home-tour-list></home-tour-list>
      <div class="home__ornament"></div>
    </div>
    <home-feature-list></home-feature-list>
    <home-about></home-about>
  </div>
</template>

<script>
import HomeTourList from "./components/tours/HomeTourList.vue";
import HomeFeatureList from "./components/features/HomeFeatureList.vue";
import HomeAbout from "./components/about/HomeAbout.vue";

export default {
  name: "Home",
  components: {
    HomeTourList,
    HomeFeatureList,
    HomeAbout
  }
};
</script>

<style scoped lang="scss">
#home {
  display: block;
}

.home__top {
  background-color: #f0f0f0;
  padding-top: 56px;
}

.home__head {
  margin: 0 auto 56px;
}

.home__title {
  font-family: "Playfair Display";
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 0.5px;
  text-align: center;
  color: #000000;
  margin-bottom: 16px;
}

.home__subtitle {
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  //font-weight: 300;
  font-size: 24px;
  letter-spacing: 0.3px;
  text-align: center;
  color: #4d4d4d;
}

.home__ornament {
  width: 100%;
  height: 188px;
  opacity: 0.1;
  background: url("../assets/ornament.svg") no-repeat;
  background-position: center center;
}

@media (max-width: 767px) {
  .home__top {
    padding-top: 24px;
    padding-bottom: 32px;
  }

  .home__head {
    margin: 0 auto 28px;
  }

  .home__title {
    font-size: 24px;
    letter-spacing: 0.3px;
    margin: 0 24px 16px;
  }

  .home__subtitle {
    font-size: 18px;
    letter-spacing: 0.23px;
    margin: 0 24px;
  }

  .home__ornament {
    background-size: contain;

    height: 72px;
    margin: 32px 0 0;
  }
}
</style>
